import { AdminUserPayload } from "./homeSlice";

// Active only in dev builds, and only when explicitly turned on: `import.meta.env.DEV`
// is replaced by Vite with a literal false in production builds, so this whole branch
// is dead code there and the bypass can never activate outside development.
export const isAuthBypassEnabled = (): boolean =>
  import.meta.env.DEV && import.meta.env["VITE_AUTH_BYPASS"] === "true";

const base64UrlEncode = (value: object): string =>
  btoa(JSON.stringify(value))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");

// Unsigned JWT (`alg: "none"`) decodable by the existing `jwtDecode` calls, standing in
// for the Google credential in local development when QG_AUTH_BYPASS is set on the back.
export const buildBypassToken = (): string => {
  const header = base64UrlEncode({ alg: "none", typ: "JWT" });
  const nowInSeconds = Math.floor(Date.now() / 1000);
  const payload: AdminUserPayload = {
    azp: "auth-bypass",
    hd: "qivia.fr",
    email: "dev@qivia.fr",
    email_verified: "true",
    at_hash: "auth-bypass",
    iat: nowInSeconds,
    exp: nowInSeconds + 60 * 60 * 24 * 365,
    name: "Dev Bypass",
    picture: "",
  };
  return `${header}.${base64UrlEncode(payload)}.`;
};
